query getSavedDesigns($limit: Int!, $pageToken: String) {
	viewer {
		id
		projectsImport {
			status
		}
		savedDesigns(limit: $limit, pageToken: $pageToken) {
			nextToken
			items {
				# ...savedDesignProject fragment. Couldn't work out how to get fragments working 
				# on client though
				id
				sourceImageKey
				sourceImageUrl
				backgroundMaskImageUrl
				colorisationImageUrl
				enhanceFacesImageUrl
				mediumImageUrl
				faceBoundingBoxes {
					x
					y
					width
					height
				}
				currentPicture {
					buildNumberOfColours
					# ...pictureConfigurationOutput fragment, but couldn't get working with client
					updatedAt

					imageZoom
					imageZoomOffset {
						x
						y
					}

					basePlateSize
					numberOfBasePlates {
						width
						height
					}

					brightness
					contrast
					saturation

					detailFilter {
						strength
						radiusRatio
					}
					dithering {
						serpentine
						clamp
						strength
					}

					removeBackground {
						newColour
					}
					enhanceFaces
					fixFaceColours

					paletteMode {
						type
						numberOfColours
						palette
					}

					pen {
						type
						value
					}
				}
				otherVersions {
					# ...pictureConfigurationOutput fragment, but couldn't get working with client
					updatedAt

					imageZoom
					imageZoomOffset {
						x
						y
					}

					basePlateSize
					numberOfBasePlates {
						width
						height
					}

					brightness
					contrast
					saturation

					detailFilter {
						strength
						radiusRatio
					}
					dithering {
						serpentine
						clamp
						strength
					}

					removeBackground {
						newColour
					}
					enhanceFaces
					fixFaceColours

					paletteMode {
						type
						numberOfColours
						palette
					}

					pen {
						type
						value
					}
				}
				updatedAt
				whoFor
				giftType
			}
		}
	}
}